// extracted by mini-css-extract-plugin
export default {"aside":"Header_aside__fbCfp","aiTeammateButton":"Header_aiTeammateButton__eEhc8","aiTeammateIcon":"Header_aiTeammateIcon__DlfWQ","topnav":"Header_topnav__gCJ06"};